import React from 'react';
import { VStack, HStack, Text, Divider, useColorModeValue } from '@chakra-ui/react';

function formatCurrency(val) {
  if (val == null) return null;
  return `$${Number(val).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

function formatPercent(val) {
  if (val == null) return null;
  return `${Number(val).toFixed(3)}%`;
}

export default function AriveFinancialCard({ loanData }) {
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  const fields = [
    { label: 'Loan Amount', value: formatCurrency(loanData.baseLoanAmount) },
    { label: 'Total Loan', value: formatCurrency(loanData.totalLoanAmount) },
    { label: 'Purchase Price', value: formatCurrency(loanData.purchasePrice) },
    { label: 'Down Payment', value: formatCurrency(loanData.downPayment) },
    { label: 'Note Rate', value: formatPercent(loanData.noteRate) },
    { label: 'LTV', value: loanData.ltv != null ? `${loanData.ltv}%` : null },
    { label: 'Back-End DTI', value: loanData.backEndDTI != null ? `${loanData.backEndDTI}%` : null },
    { label: 'Front-End DTI', value: loanData.frontEndDTI != null ? `${loanData.frontEndDTI}%` : null },
    { label: 'FICO', value: loanData.fico },
  ].filter((f) => f.value != null);

  const revenueFields = [
    { label: 'Gross Revenue', value: formatCurrency(loanData.grossLoanRevenue) },
    { label: 'Net Revenue', value: formatCurrency(loanData.netLoanRevenue) },
    { label: 'Compensation', value: loanData.compensation },
    { label: 'Broker Fee', value: formatCurrency(loanData.brokerFee) },
  ].filter((f) => f.value != null);

  if (fields.length === 0 && revenueFields.length === 0) {
    return <Text fontSize="xs" color={mutedColor}>No financial data available</Text>;
  }

  return (
    <VStack align="stretch" spacing={1}>
      {fields.map((f) => (
        <HStack key={f.label} justify="space-between">
          <Text fontSize="xs" color={mutedColor}>{f.label}</Text>
          <Text fontSize="xs" fontWeight="medium">{f.value}</Text>
        </HStack>
      ))}
      {revenueFields.length > 0 && (
        <>
          <Divider my={1} />
          {revenueFields.map((f) => (
            <HStack key={f.label} justify="space-between">
              <Text fontSize="xs" color={mutedColor}>{f.label}</Text>
              <Text fontSize="xs" fontWeight="medium">{f.value}</Text>
            </HStack>
          ))}
        </>
      )}
    </VStack>
  );
}
